import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import { Icon } from "@qgiv/core-react";
import { CardInput } from "@qgiv/core-donor";

const RoleCard = ({
    id,
    name,
    title,
    value,
    registrationRef,
    renderSelectedExtraTitle = (_title) => (
        <>
            <span className="-type--large">
                <Icon glyph="pencil-alt-regular" type="FontAwesome" />
            </span>
            <span className="-visually-hidden">{_title}</span>
        </>
    ),
    handleClick = () => {},
    handleChange = () => {},
    ...props
}) => {
    const [{ ...field }] = useField({
        name,
        type: "checkbox",
        value,
    });

    const classNames = ["-visually-hidden", "-same--disabled"];
    const cardProps = {
        ...field,
        ...props,
        classNames,
        handleChange,
        handleClick,
        id,
        title,
        type: "checkbox",
    };
    if (field.checked && !props.disabled) {
        const renderExtraTitle = renderSelectedExtraTitle;
        cardProps.extraTitle = "Change Registration Role";
        cardProps.renderExtraTitle = renderExtraTitle;
    }
    return <CardInput {...cardProps} ref={registrationRef} />;
};

RoleCard.propTypes = {
    disabled: PropTypes.bool.isRequired,
    handleChange: PropTypes.func,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    teamModalOpen: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(["radio", "checkbox"]),
    setAppTeamModalOpen: PropTypes.func,
    value: PropTypes.string.isRequired,
    registrationRef: PropTypes.shape({}).isRequired,
    renderSelectedExtraTitle: PropTypes.func,
    handleClick: PropTypes.func,
};

export default RoleCard;
